//menu que se despliega al clickear el avatar del perfil en el navbar
import React from 'react';
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { Menu, MenuItem, ListItemIcon, Divider, Box } from '@mui/material';
import { PersonOutlineOutlined, ShoppingCartOutlined, ExitToAppOutlined } from '@mui/icons-material';
import { useTranslation } from "react-i18next";

const ProfileMenu = ({ anchorEl, open, handleClose, logoutWithRedirect, closeMenus, user }) => {
  const [t] = useTranslation("global");

  const handleItemClose = () => {
    document.activeElement?.blur();
    handleClose();
  };

  const menuItemSx = {
    color: "#4B4D63",
    fontSize: "15px",
    fontWeight: 500,
    fontFamily: "Bricolage Grotesque",
    textDecoration: "none",
    borderRadius: '6px',
    mx: 0.5,
    px: 1.5,
    py: 0.75,
    gap: 1,
    '&:hover': {
      backgroundColor: 'rgba(11, 0, 98, 0.06)',
      color: '#0b0062',
      '& .MuiListItemIcon-root': {
        color: '#0b0062',
      },
    },
  };

  return (
    <Menu
      id="profile-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={handleItemClose}
      MenuListProps={{ "aria-labelledby": "profileDropdown", sx: { py: 0.5 } }}
      PaperProps={{
        sx: {
          minWidth: 180,
          backgroundColor: '#ffffff',
          borderRadius: '8px',
          boxShadow: '0px 8px 24px rgba(11, 0, 98, 0.12), 0px 2px 8px rgba(0,0,0,0.08)',
          border: '1px solid rgba(75, 77, 99, 0.1)',
          overflow: 'hidden',
          mt: 1,
        }
      }}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
    >
      {/* {user && (
        <Box sx={{
          px: 2,
          py: 1.25,
          borderBottom: '1px solid rgba(75, 77, 99, 0.08)',
          mb: 0.5,
        }}>
          <span style={{
            fontSize: '12px',
            fontFamily: 'Bricolage Grotesque',
            fontWeight: 600,
            color: '#9496aa',
            textTransform: 'uppercase',
            letterSpacing: '0.08em',
            display: 'block',
          }}>
            Mi cuenta
          </span>
          {(user.nombre || user.usuario) && (
            <span style={{
              fontSize: '13px',
              fontFamily: 'Bricolage Grotesque',
              fontWeight: 500,
              color: '#4B4D63',
              display: 'block',
              marginTop: '2px',
            }}>
              {user.nombre ? `${user.nombre} ${user.apellido || ''}`.trim() : user.usuario?.split('@')[0]}
            </span>
          )}
        </Box>
      )} */}

      <MenuItem component={Link} to="/profile" onClick={handleItemClose} sx={menuItemSx}>
        <ListItemIcon sx={{ minWidth: "36px", color: "#4B4D63" }}>
          <PersonOutlineOutlined fontSize="small" />
        </ListItemIcon>
        {t("navbar.profile")}
      </MenuItem>

      <MenuItem component={Link} to="/mis-compras" onClick={handleItemClose} sx={menuItemSx}>
        <ListItemIcon sx={{ minWidth: "36px", color: "#4B4D63" }}>
          <ShoppingCartOutlined fontSize="small" />
        </ListItemIcon>
        Mis compras
      </MenuItem>

      <Divider sx={{ my: 0.5, borderColor: 'rgba(75, 77, 99, 0.08)' }} />

      <MenuItem
        onClick={() => { logoutWithRedirect(); handleClose(); }}
        sx={{ ...menuItemSx, color: '#c0392b', '&:hover': { backgroundColor: 'rgba(192, 57, 43, 0.06)', color: '#c0392b', '& .MuiListItemIcon-root': { color: '#c0392b' } } }}
      >
        <ListItemIcon sx={{ minWidth: "36px", color: "#c0392b" }}>
          <ExitToAppOutlined fontSize="small" />
        </ListItemIcon>
        Cerrar sesión
      </MenuItem>
    </Menu>
  );
};

export default ProfileMenu;